import SurveysService from '../../services/surveys-service'

Vue.component('my-surveys', {
    mounted() {
        this.getSurveys(1);
    },
    data() {
        return {
            results: {},
            modalSurveys: null,
            adhocEmailsToSend: '',
            invalidEmails: [],
            loading: false,
            includeArchived: false,
        }
    },
    computed: {
        isViewSurveysPermission() {

            let permissions = [];

            if (typeof Spark.userPermissions === 'string') {
                try {
                    permissions = JSON.parse(Spark.userPermissions);
                } catch (error) {
                    console.error("Failed to parse user permissions:", error);
                }
            } else if (Array.isArray(Spark.userPermissions)) {
                permissions = Spark.userPermissions;
            }

            return permissions.includes('view_surveys') && permissions.length === 1;
        }
    },
    methods: {
        async openSurveySelector() {
            $(this.$refs.selector_modal).modal()
            if (!this.modalSurveys) {
                const allSurveys = await SurveysService.indexAll(1);
                this.modalSurveys = allSurveys;
            }
        },
        async getSurveys(page) {
            this.loading = true
            this.results = await SurveysService.index(page, this.includeArchived)

            this.$nextTick(function () {
                this.loading = false
            })

            return true;
        },
        async getModalSurveys(page) {
            this.modalSurveys = await SurveysService.indexAll(page)
        },
        async downloadReport(responseId) {
            SurveysService.reports.download(responseId)
        }
    }
});
